import { russian } from './russian'
import { math } from './math'
import { physics } from './physics'
import { law } from './law'

export const MarathonData = [russian, math, physics, law]
